FiltersMdl.directive( "effectFan", ['$templateCache', function( $templateCache ) {
	return {
		restrict: 'E',
		replace: true,
		template: $templateCache.get('Filters/Effect-Fans/Templates/_effect-fan.tpl.html'),
		controller: [ '$scope', function( $scope ){
			var states = {
				'monovalent-effect-fan': 'main.categories.families.effects',
				'neutral-effect-fan': 'main.categories.families.effects.colors',
				'neutral-schlicht-fan': 'main.categories.families.effects.colors'
			};



			this.state = states[ $scope.fan.fan_type ];
		}],
		controllerAs: 'effect_fan_state',
		bindToController: true
	}
}]);
